export const styleExplorer = {
  main: { height: "100%" },
  content: {
    display: "flex",
    flex: 1,
    overflowY: "auto",
    padding: 0.5,
  },
};
